import { dictionary } from "../dictionary";

export const isLanguageSupported = (lang:string) => {
	return Object.keys(dictionary).indexOf(lang) > -1; 
};